import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { FiAlignRight, FiXCircle, FiChevronDown } from "react-icons/fi";
import "./Navbarmenu.css";
import { useMsal } from "@azure/msal-react";
// import '/node_modules/bootstrap/dist/css/bootstrap.min.css'

const Navbarmenu = () => {
  const [isMenu, setisMenu] = useState(false);
  const [isResponsiveclose, setResponsiveclose] = useState(false);
  const [isAdminSubMenu, setAdminSubMenu] = useState(false);

  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  let loggedInEnterpriseId = "";
  if (activeAccount)
    loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;
  const allowedUsersForContibution = [
    "aluru.akash",
    "ankur.e.mishra",
    "h.srinivasan",
    "jeevadharani.ramanan",
    "arpita.m.singh",
    "uma.rani.battu",
    "reshmi.haridas.m",
    "aayushi.bharti",
    "lavanya.umesh",
    "shramika.s.ambolkar",
    "srikanth.narabathoju",
  ];

  const toggleClass = () => {
    setisMenu(isMenu === false ? true : false);
    setResponsiveclose(isResponsiveclose === false ? true : false);
  };

  const toggleMenu = () => {
    setisMenu(!isMenu);
    setResponsiveclose(!isResponsiveclose);
  };

  const toggleAdminSubmenu = () => {
    setAdminSubMenu(!isAdminSubMenu);
  };

  const hideMenu = () => {
    setisMenu(false);
    setAdminSubMenu(false);
  };

  let boxClass = ["main-menu"];
  if (isMenu) {
    boxClass.push("menuq2");
  } else {
    boxClass.push("");
  }

  const [isMenuSubMenu, setMenuSubMenu] = useState(false);
  const toggleSubmenu = () => {
    setMenuSubMenu(isMenuSubMenu === false ? true : false);
  };
  let boxClassSubMenu = ["sub__menus"];
  if (isMenuSubMenu) {
    boxClassSubMenu.push("sub__menus__Active");
  } else {
    boxClassSubMenu.push("");
  }

  return (
    <header className="header__middle">
      <div className="head-container">
        <div className="row-fluid">
          <div className="header__middle__menus">
            <nav className="main-nav ">
              {/* Responsive Menu Button */}
              {isResponsiveclose === true ? (
                <>
                  <span
                    className="menubar__button"
                    style={{ display: "none" }}
                    onClick={toggleClass}
                  >
                    <FiXCircle />
                  </span>
                </>
              ) : (
                <>
                  <span
                    className="menubar__button"
                    style={{ display: "none" }}
                    onClick={toggleClass}
                  >
                    <FiAlignRight />
                  </span>
                </>
              )}
              <ul className={boxClass.join(" ")}>
                <li className="menu-item">
                  <a
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    href="https://atc.l-tt.accenture.com/Home"
                  >
                    L&TT Home
                  </a>
                </li>
                <li className="menu-item">
                  <NavLink
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    to={`/home`}
                  >
                    Home
                  </NavLink>
                </li>
                {allowedUsersForContibution.includes(loggedInEnterpriseId) && (
                  <li
                    className="menu-item sub__menus__arrows"
                    onClick={toggleAdminSubmenu}
                  >
                    <a
                      className="nav-links"
                      aria-expanded={isAdminSubMenu ? "true" : "false"}
                      aria-haspopup="true"
                      tabIndex="0"
                      onClick={(e) => {
                        e.preventDefault();
                        toggleAdminSubmenu();
                      }}
                    >
                      Admin
                      <span>
                        <FiChevronDown />
                      </span>
                    </a>

                    <ul className={boxClassSubMenu.join(" ")}>
                      <li onClick={hideMenu}>
                        <NavLink
                          className="nav-links"
                          onClick={toggleMenu}
                          to="/AnalyticsPage"
                          //target="_blank"
                        >
                          Analytics
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                )}
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbarmenu;
